import React, { useState, useEffect } from 'react';

// ─── Inline Styles for Dark Theme ──────────────────────────────────────────────
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600&display=swap');

  .admin-wrapper {
    background: #0a0a0a;
    color: #f0f0f0;
    min-height: 100vh;
    padding: 3rem 2rem;
    font-family: 'DM Sans', sans-serif;
  }
  .admin-container {
    max-width: 1000px;
    margin: 0 auto;
  }
  .admin-card {
    background: #111111;
    border: 1px solid #2a2a2a;
    border-radius: 8px;
    padding: 2.5rem;
    margin-bottom: 2rem;
  }
  .admin-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 2.5rem;
    letter-spacing: 0.06em;
    margin-bottom: 1.5rem;
  }
  .admin-title span {
    color: #e8ff3c; /* Yellow accent */
  }
  .msg-box {
    padding: 1rem;
    background: rgba(232, 255, 60, 0.1);
    color: #e8ff3c;
    border: 1px solid rgba(232, 255, 60, 0.2);
    border-radius: 6px;
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
  }
  
  /* Form Styles */
  .admin-form label {
    display: block;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #666;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  .admin-form input, .admin-form select {
    width: 100%;
    background: #1a1a1a;
    border: 1px solid #2a2a2a;
    color: #f0f0f0;
    border-radius: 6px;
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    font-family: 'DM Sans', sans-serif;
    outline: none;
    transition: border-color 0.2s;
  }
  .admin-form input:focus, .admin-form select:focus {
    border-color: #e8ff3c;
  }
  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .form-group {
    margin-bottom: 1.5rem;
  }
  .btn-submit {
    background: #e8ff3c;
    color: #000;
    border: none;
    border-radius: 4px;
    padding: 0.85rem 2rem;
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: opacity 0.2s;
    width: 100%;
  }
  .btn-submit:hover:not(:disabled) {
    opacity: 0.85;
  }
  .btn-submit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Table Styles */
  .admin-table-wrap {
    overflow-x: auto;
  }
  .admin-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  .admin-table th {
    padding: 1rem;
    border-bottom: 1px solid #2a2a2a;
    color: #666;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
  .admin-table td {
    padding: 1rem;
    border-bottom: 1px solid #1a1a1a;
    vertical-align: middle;
    font-size: 0.9rem;
  }
  .admin-table tr:hover {
    background: rgba(255, 255, 255, 0.02);
  }
  .accent-text {
    color: #e8ff3c;
    font-family: monospace;
  }
  .btn-delete {
    background: transparent;
    color: #ff4545;
    border: 1px solid rgba(255, 69, 69, 0.3);
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 600;
    transition: all 0.2s;
  }
  .btn-delete:hover {
    background: rgba(255, 69, 69, 0.1);
    border-color: #ff4545;
  }
  
  /* Native audio player styling */
  audio {
    height: 32px;
    max-width: 220px;
    border-radius: 4px;
  }
  
  @media (max-width: 768px) {
    .form-row { grid-template-columns: 1fr; gap: 0; }
  }
`;

const MusicManager = () => {
  // Get token from local storage to authenticate requests
  const token = localStorage.getItem("token");

  // State for data
  const [musicList, setMusicList] = useState([]);
  const [categories, setCategories] = useState([]);
  
  // State for form
  const [file, setFile] = useState(null);
  const [price, setPrice] = useState('');
  const [pricePremium, setPricePremium] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  // State for UI
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchCategories();
    fetchMusicList();
  }, []);

 const fetchCategories = async () => {
    try {
      const response = await fetch('http://localhost:8080/iMusic/user/category/listadmin');
      const data = await response.json();
      
      // Strictly enforce that we are saving an array
      const categoryArray = Array.isArray(data?.response) 
        ? data.response 
        : (Array.isArray(data) ? data : []);
        
      setCategories(categoryArray);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setCategories([]); 
    }
  };

  const fetchMusicList = async () => {
    try {
      const response = await fetch('http://localhost:8080/iMusic/user/music/listadmin');
      const data = await response.json();
      
      // Strictly enforce that we are saving an array
      const musicArray = Array.isArray(data?.response) 
        ? data.response 
        : (Array.isArray(data) ? data : []);
        
      setMusicList(musicArray);
    } catch (error) {
      console.error('Error fetching music:', error);
      setMusicList([]); 
    }
  };

  const handleAddMusic = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    if (!file) {
      setMessage('Please select a music file to upload.');
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append('music', file);
    formData.append('price', price);
    formData.append('pricepremium', pricePremium);
    formData.append('category', selectedCategory);

    try {
      const response = await fetch('http://localhost:8080/iMusic/user/music/add', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}` // Added the token to authorize the upload
        },
        body: formData,
      });

      if (response.ok) {
        setMessage('Music added successfully! 🎵');
        setFile(null);
        setPrice('');
        setPricePremium('');
        setSelectedCategory('');
        
        // Reset file input UI manually
        document.getElementById('musicFileInput').value = '';
        
        fetchMusicList();
      } else {
        const errorData = await response.json().catch(() => ({}));
        setMessage(errorData.error || errorData.message || 'Failed to add music.');
      }
    } catch (error) {
      console.error('Error adding music:', error);
      setMessage('An error occurred while adding music.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this track?')) return;

    try {
      const response = await fetch(`http://localhost:8080/iMusic/user/music/delete/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` // Added the token to authorize the deletion
        }
      });

      if (response.ok) {
        setMessage('Music deleted successfully.');
        fetchMusicList();
      } else {
        setMessage('Failed to delete music.');
      }
    } catch (error) {
      console.error('Error deleting music:', error);
      setMessage('An error occurred while deleting.');
    }
  };

  return (
    <div className="admin-wrapper">
      <style>{styles}</style>
      
      <div className="admin-container">
        
        {message && <div className="msg-box">{message}</div>}

        {/* --- ADD MUSIC FORM --- */}
        <div className="admin-card">
          <h2 className="admin-title">ADD <span>MUSIC</span></h2>
          
          <form onSubmit={handleAddMusic} className="admin-form">
            <div className="form-group">
              <label>Music File (MP3/WAV)</label>
              <input 
                id="musicFileInput"
                type="file" 
                accept="audio/*"
                onChange={(e) => setFile(e.target.files[0])} 
                required 
              />
            </div>

            <div className="form-row">
              <div>
                <label>Standard Price (USD)</label>
                <input 
                  type="number" 
                  step="0.01"
                  placeholder="e.g. 25.00"
                  value={price} 
                  onChange={(e) => setPrice(e.target.value)} 
                  required 
                />
              </div>

              <div>
                <label>Premium Price (USD)</label>
                <input 
                  type="number" 
                  step="0.01"
                  placeholder="e.g. 100.00"
                  value={pricePremium} 
                  onChange={(e) => setPricePremium(e.target.value)} 
                  required 
                />
              </div>
            </div>

            <div className="form-group">
              <label>Genre / Category</label>
              <select 
                value={selectedCategory} 
                onChange={(e) => setSelectedCategory(e.target.value)} 
                required
              >
                <option value="" disabled>Select a category...</option>
                {categories.map((cat) => (
                  <option key={cat.id || cat.category} value={cat.category}>
                    {cat.category}
                  </option>
                ))}
              </select>
            </div>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Uploading File...' : 'Upload Beat'}
            </button>
          </form>
        </div>

        {/* --- MUSIC LIST --- */}
        <div className="admin-card">
          <h2 className="admin-title">MUSIC <span>LIBRARY</span></h2>
          
          {musicList.length === 0 ? (
            <p style={{ color: '#666' }}>No beats found in the database.</p>
          ) : (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Category</th>
                    <th>Preview</th>
                    <th>Standard</th>
                    <th>Premium</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {musicList.map((music) => (
                    <tr key={music.id}>
                      <td className="accent-text">#{music.id}</td>
                      <td>{music.category}</td>
                      
                      {/* Audio Preview Column */}
                      <td>
                        {music.music ? (
                          <audio 
                            controls 
                            controlsList="nodownload" 
                            preload="none"
                            src={`http://localhost:8080${music.music}`} 
                          />
                        ) : (
                          <span style={{ color: '#666', fontSize: '0.8rem' }}>No Audio</span>
                        )}
                      </td>

                      <td>${Number(music.price).toFixed(2)}</td>
                      <td>${Number(music.pricepremium).toFixed(2)}</td>
                      <td>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(music.id)}
                        >
                          ✕ Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MusicManager;